import { render, staticRenderFns } from "./If65Select.vue?vue&type=template&id=45ad47cc&scoped=true"
import script from "./If65Select.vue?vue&type=script&lang=js"
export * from "./If65Select.vue?vue&type=script&lang=js"
import style0 from "./If65Select.vue?vue&type=style&index=0&id=45ad47cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ad47cc",
  null
  
)

export default component.exports